// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const PersonService = {
    GetPersonLegacy(fn, req) {
        try {
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/persons/v3/persons/${req["personId"]}?${fm.renderURLSearchParams(req, ["personId"])}`, { method: "GET" });
    },
    ListPersonsLegacy(fn, req) {
        return fn(`/persons/v3/persons?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListPersonsByPhoneLegacy(fn, req) {
        return fn(`/persons/v3/phone?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListPreferredPersonsByPhoneLegacy(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/persons/v3/locations/${req["locationId"]}/preferred-persons?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    UpsertPrimaryContactLegacy(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/persons/v3/locations/${req["locationId"]}/primary-contact`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetPrimaryContactLegacy(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/persons/v3/locations/${req["locationId"]}/primary-contact?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    SearchPersonsLegacy(fn, req) {
        return fn(`/persons/v3/persons/search?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SearchPersonsLegacyPost(fn, req) {
        return fn(`/persons/v3/persons/search`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    SearchPersonsByPMIDLegacy(fn, req) {
        return fn(`/persons/v3/persons/search-pmid?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetPersonsCountLegacy(fn, req) {
        return fn(`/persons/v3/persons/count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateLangPreferenceLegacy(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/persons/v3/locations/${req["locationId"]}/persons/${req["personId"]}/preferences/lang`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
};
